import { injectCSSandScripts } from './helpers/injectHtml'
import { setupCheckout } from './helpers/sdk'
setupCheckout()
injectCSSandScripts()
